import ApiServer from "../ApiServer.ts";
import FizConfig from "../FizConfig.ts";
import deviceId from "../lib/deviceId.ts";
import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modal from "../util/modal.ts";
import * as libLocation from "../lib/location.ts";
import * as Html from "../util/Html.ts";
import * as ga from "../tracking-googleanalytics.ts";
import * as Storage from "../lib/Storage.ts";
import { clearAuthorization, setAuthorization } from "../server/Authorization.ts";

ApiServer.log2generateaccesstokenbypassword = ApiServer.log2generateaccesstokenbypassword.prepare({
  tokentype:"Bearer",
  deviceId:deviceId
},function(accessTokenBean){
  ga.event({
    'event': 'login',
    'form_name': 'signin form'
  })
  Storage.sessionSet('needsegmentidentify','true');
  let authorization = accessTokenBean.token_type + " " + accessTokenBean.access_token;
  setAuthorization(authorization,Storage.localGet("rememberme")==='true')

})

ApiServer.log2getdeeplinkinfo = ApiServer.log2getdeeplinkinfo.prepare({
  tokentype:"Bearer",
  deviceId:deviceId
},function(accessTokenBean){
  ga.event({
    'event': 'login',
    'form_name': 'deeplink'
  })
  if(accessTokenBean.accessToken){
    Storage.sessionSet('needsegmentidentify','true');
    let authorization = accessTokenBean.accessToken.token_type + " " + accessTokenBean.accessToken.access_token;
    setAuthorization(authorization,false)
  }
})


//logout handling
amplify.subscribe("sessionExpired",async function(data){
  //if we autologged less than 10 seconds ago it is not an issue of cookie acceptance
  FwDatas.reset();
  clearAuthorization()
  libLocation.goTo('fw2_signin.php');

});

export function logoutWantedByUser(){
  if(deviceId){
    ApiServer.devicedelete(deviceId);
  }
  ApiServer.log2out().finally(()=>{
    amplify.publish("sessionExpired",{fromUser:true});
  });
}
Html.registerDom({
  logout:logoutWantedByUser,
  termsaccept(){
    ApiServer.accsetterms(true,function(){
      libLocation.goTo(INR.URL.ENTER_HOME);
    })
  },
  termsdecline(){
    import("../modal/termsdecline.mustache").then(TPL_TERMS_DECLINE=>modal.openDomModal(TPL_TERMS_DECLINE,{}));
  }
});